// REVEAL ШАГА 4 — расписание волн и подпись волны. B6-4 `34a19875cbb881659219fa582fad0f62`.
//
// ИСТОЧНИК ТАЙМИНГОВ — байт борда `Life Map - s4 Layered Map v10.html` (sha256 `ed131e8b…e9a5`),
// `reveal()` `:515–532` и `settle()` `:533–541`; `WAVES` — `:294`. Где борд и спека s4 расходятся,
// права спека (`s743.d1`): подпись волны — `s4.reveal.wave`, решения `s493.d3` + `s620.d2`.
//
// ⛔ ИМЕНИ СЕМЬИ В ПОДПИСИ НЕТ (`s493.d3`, `s618` п. 2). Борд клеит `FAMNAME[…] · ` перед именами
// (`:526`) — служебная терминология, в интерфейсе её больше нет. Словаря семей здесь нет вовсе.
//
// ⏳ ПРИГЛУШЁННОЙ CTA ПОКА НЕТ: кнопка видима и в полную с первого кадра. Развилка `s601.d1` п. 6 ↔
// DoR B6-4 решена `s956.d2` — бледная на время reveal на ОБОИХ шагах 4 и 5; исполнение — B6-7
// (`3ec19875cbb88115845bd302912cafcf`), ждёт вид от CD. До него гард «не приглушается» в
// `StepFour.reveal.test.jsx` описывает текущее поведение, а не правило.

/**
 * «Один раз за сессию» (`s956.d2` п. 2, B6-6) — токен `'s4'` в `revealsPlayed` конверта, по образцу
 * шага 5 (`s952.d2`, `s5Reveal.js`). Отдельного ключа хранилища нет, форма конверта не меняется
 * (массив токенов уже есть) — версия конверта не поднимается. Сброс — только `start over` (`s866.d1`).
 */
export const REVEAL_TOKEN = 's4';

/** Сыгран ли reveal шага 4 в этой сессии. */
export function revealPlayed(revealsPlayed) {
  return Array.isArray(revealsPlayed) && revealsPlayed.includes(REVEAL_TOKEN);
}

/** Записать reveal в сыгранные. Прежний массив, если токен уже там (держатель сравнивает по ссылке). */
export function rememberReveal(revealsPlayed) {
  const played = Array.isArray(revealsPlayed) ? revealsPlayed : [];
  return played.includes(REVEAL_TOKEN) ? played : [...played, REVEAL_TOKEN];
}

/** Волны reveal — ключи слоёв в порядке появления (`WAVES` `:294`). */
export const WAVES = Object.freeze([
  Object.freeze(['Vitality', 'Wanting']),
  Object.freeze(['Growth', 'Yourself']),
  Object.freeze(['Security', 'Authorship', 'Lasting']),
]);

/**
 * Кадры, мс от монтирования. Каждое число — байт v10:
 *   · `GAPS`     `:521` — старт каждой волны;
 *   · `D`        `:521` — ход одной волны (раскрытие слоя от силуэта к своим значениям);
 *   · `SIL_OUT`  `:524` — силуэт средних начинает гаснуть (`opacity .9s ease-out`, `:519`);
 *   · `SAFETY`   `:527` — `RVTO`: не в покое к этому моменту — в покой без задержки находки;
 *   · `FIND_LAG` `:540` — находка проявляется через столько после ЕСТЕСТВЕННОГО конца или `skip`
 *     (`settle()` без `quiet`); при страховке, тапе по слою/колонке и reduced motion — сразу.
 */
export const RV4 = Object.freeze({ GAPS: Object.freeze([250, 1000, 1750]), D: 820, SIL_OUT: 520, SAFETY: 2900, FIND_LAG: 1200 });

/** Естественный конец: последняя волна доиграла (1750 + 820). Раньше страховки. */
export const RV4_END = RV4.GAPS[RV4.GAPS.length - 1] + RV4.D;

/** Кривая хода волны (`:521`): ease-out cubic. */
export const ease = (x) => 1 - Math.pow(1 - x, 3);

/** Ход волны `wi` к моменту `now`, 0…1 (`step()` `:528–530`). */
export function waveProgress(wi, now) {
  return ease(Math.max(0, Math.min(1, (now - RV4.GAPS[wi]) / RV4.D)));
}

/** `s4.reveal.caption` (борд `:523`) — строка до первой волны. */
export const REVEAL_CAPTION = 'one line · seven layers underneath';

/** `s4.cta.skip` (борд `:499`). */
export const SKIP_LABEL = 'skip';

/**
 * Подпись волны (`s4.reveal.wave`): имена НАРИСОВАННЫХ слоёв волны через ` · `, без имени семьи.
 * Волна без нарисованных слоёв подпись не меняет (`s620.d2`) — `null`, и стоит предыдущая.
 *
 * @param {number} wi индекс волны
 * @param {Array<{key:string,name:string}>} layers слои экрана (`S4_LAYERS`)
 * @param {boolean[]} drawn нарисован ли слой, по индексу `layers`
 * @returns {string|null}
 */
export function waveCaption(wi, layers, drawn) {
  const names = WAVES[wi]
    .map((k) => layers.findIndex((L) => L.key === k))
    .filter((li) => li >= 0 && drawn[li])
    .map((li) => layers[li].name);
  return names.length ? names.join(' · ') : null;
}

/**
 * Что стоит в полосе подписи к моменту `now`: строка до первой волны, затем последняя волна С
 * СОДЕРЖИМЫМ. `{ intro: true }` — курсивная вводная, `{ names }` — имена волны.
 */
export function captionAt(now, layers, drawn) {
  let cur = { intro: true, text: REVEAL_CAPTION };
  RV4.GAPS.forEach((gap, wi) => {
    if (now < gap) return;
    const names = waveCaption(wi, layers, drawn);
    if (names !== null) cur = { intro: false, text: names };
  });
  return cur;
}

/** Волна слоя по ключу, или -1. */
export function waveOf(key) {
  return WAVES.findIndex((w) => w.includes(key));
}
